<template>
  <div>
    <!-- Page Header -->
    <div class="page-header">
      <div class="page-title">
        <h4>{{ $t("user_list") }}</h4>
      </div>

      <div class="page-btn" v-if="can('rbac.user', 'W')">
        <router-link to="/users/create" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>
          {{ $t("add_new_user") }}
        </router-link>
      </div>
    </div>

    <div class="card table-list-card">
      <div class="card-body">
        <div class="table-responsive">

          <!-- TABLE -->
          <DataTable v-if="users.length" :tableId="'usersTable'">
            <thead>
              <tr>
                <th>{{ $t("user_name") }}</th>
                <th>{{ $t("user_email") }}</th>
                <th>{{ $t("phone_number") }}</th>
                <th>{{ $t("user_role") }}</th>
                <th>{{ $t("store") }}</th>
                <th>{{ $t("status") }}</th>
                <th class="no-sort">{{ $t("action") }}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="u in users" :key="u.id">
                <td>{{ u.username }}</td>
                <td>{{ u.email }}</td>
                <td>{{ u.phone_number }}</td>

                <!-- Since serializer returns string -->
                <td>{{ u.role || "-" }}</td>
                <td>{{ u.store || "-" }}</td>

                <td>
                  <span class="badge bg-success" v-if="u.is_active">Active</span>
                  <span class="badge bg-danger" v-else>Inactive</span>
                </td>

                <td class="action-table-data">
                  <div class="edit-delete-action" v-if="can('rbac.user', 'E')">
                    <router-link
                      :to="{ name: 'UserEdit', params: { id: u.id } }"
                      class="btn btn-added"
                    >
                      <i class="ti ti-edit me-2"></i>
                      {{ $t("edit_user") }}
                    </router-link>
                  </div>
                </td>
              </tr>
            </tbody>
          </DataTable>

          <!-- NO DATA -->
          <div v-else class="text-center p-5 text-muted">
            No Users Found
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import DataTable from "@/components/common/DataTable.vue";

export default {
  inject: ["globalLoading"],
  components: { DataTable },

  data() {
    return {
      users: [],
    };
  },

  methods: {
    async fetchUsers() {
      this.globalLoading(true);

      try {
        const res = await this.$axios.get(apiUrls.users.get);

        // Always returns array
        this.users = res.data.results || res.data || [];

      } catch (err) {
        console.error("Error loading users:", err);
      } finally {
        this.globalLoading(false);
      }
    },

    can(code, requiredLevel) {
      const perms = JSON.parse(localStorage.getItem("permissions")) || {};
      const userLevel = perms[code] || 'N';

      for (const char of requiredLevel) {
        if (!userLevel.includes(char)) {
          return false;
        }
      }
      return true;
    },
  },

  created() {
    this.fetchUsers();
  },
};
</script>
